export default "__VITE_PUBLIC_ASSET__8810b414__"